.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 16px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.carouselSkeleton {
  /* `height: auto` neutralizes Skeleton.Bone's default `height: var(--height)`
     so the aspect-ratio drives the bone's height (matching the real carousel). */
  height: auto;
  aspect-ratio: 343 / 240;
}

.imageBannerSkeleton {
  height: 240px;
}

@media all and (--reefer-media-tablet-min) {
  .carouselSkeleton {
    aspect-ratio: 1312 / 320;
  }
}
